"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shapeColumn = exports.shape = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    from {\n        transform: translateY(-100%);\n    }\n    to {\n        transform: translateY(100%);\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    from {\n        transform: translateX(-100%);\n    }\n    to {\n        transform: translateX(100%);\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var shape = (0, _styledComponents.keyframes)(_templateObject());
exports.shape = shape;
var shapeColumn = (0, _styledComponents.keyframes)(_templateObject2());
exports.shapeColumn = shapeColumn;